import React from "react"
import { BlacklistProvider } from "./src/context/BlacklistContext"

export const wrapRootElement = ({ element }) => (
  <BlacklistProvider>
    {element}
  </BlacklistProvider>
);

